package org.vreo.devicehub.features.vrmOutput.presentation

import org.vreo.devicehub.features.core.domain.device.vrmConfig.VrmOutputConfig
import org.vreo.devicehub.features.core.presentation.UiText
import org.vreo.devicehub.features.vrmOutput.domain.models.TimeZoneDisplay


/**
 * Vrm output ui state
 */
data class VrmOutputState(
    // State of view model.
    val isLoading: Boolean = false,
    val error: UiText? = null,
    val isDeviceActive: Boolean = false,

    val deviceHubReportingEnabled: Boolean = false,

    // List of VRMs
    val selectedVrmId: Int? = null,
    val vrmConfigurations: List<VrmOutputConfig> = emptyList(),

    // Error/invalid state
    val invalidVrmEndpoint: Boolean = false,
    val invalidConfidenceScoreLimit: Boolean = false,
    val invalidTimeoutSeconds: Boolean = false,

    // User selected values.
    val vrmEnabled: Boolean = false,
    val vrmTypeIndex: Int = 0,
    val vrmEndpoint: String = "",
    val vrmApiKey: String = "",
    val vrmSiteId: String = "",
    val useRoiIdAsBayId: Boolean = false,
    val roiIdIndex: Int = 0,
    val vrmBayIdentifier: String = "",
    val vrmConfidenceThreshold: String = "70.0",
    val vrmTimeoutSeconds: String = "10.0",
    val vrmVerifySsl: Boolean = false,

    // Overlayer
    val enableOverlayer: Boolean = false,
    val overlayerPositionIndex: Int = 0,
    val enableOverlayerLabel: Boolean = false,
    val overlayerLabel: String = "",
    val enableOverlayerOcrResults: Boolean = true,
    val enableOverlayerBayId: Boolean = true,
    val enableOverlayerSiteId: Boolean = true,
    val enableOverlayerDateTime: Boolean = false,

    // Timezone
    val selectedTimeZoneIndex: Int = 0,
    val availableTimeZones: List<TimeZoneDisplay> = emptyList(),
)

